import { Controller } from "@hotwired/stimulus"

// This controller can be used to dispatch an event using stimulus actions or when this controller is connected,
// you should only use this if you don't have specialized stimulus controller.
export default class extends Controller {
  static get values() {
    return {
      eventName: String,
      onConnect: { type: Boolean, default: false },
    }
  }

  connect() {
    if (this.onConnectValue) {
      this.dispatch(this.eventNameValue || "dispatch-event")
      this.element.remove()
    }
  }

  dispatchEvent(event) {
    if (event.params.preventDefault) {
      event.preventDefault()
    }

    let eventName = event.params.eventName || this.eventNameValue || "dispatch-event"
    this.dispatch(eventName, {
      details: {
        element: this.element,
        eventParams: event.params
      },
      detail: {
        element: this.element,
        eventParams: event.params
      }
    })
  }
}
